const STAFF_USER_ROLE_OPTIONS: { value: string; label: string }[] = [
  { value: "BILLER", label: "Biller" },
  { value: "ENB", label: "Enb" },
  { value: "FRONTDESK", label: "Front Desk" },
  { value: "NURSE", label: "Nurse" },
  // { value: "PSYCHIATRIST", label: "Psychiatrist" },
  // { value: "RESOLUTION_SPECIALIST", label: "Resolution Specialist" },
  // { value: "THERAPIST", label: "Therapist" },
];

export const ROLE_RECORD: Record<string, string> = {
  ...STAFF_USER_ROLE_OPTIONS.reduce(
    (obj, item) => {
      obj[item.value] = item.label;
      return obj;
    },
    {} as Record<string, string>
  ),

  SUPER_ADMIN: "Super Admin",
};

export { STAFF_USER_ROLE_OPTIONS };

export const PROVIDER_TYPE_LIST = [
  { value: "MD", label: "MD" },
  { value: "DO", label: "DO" },
  { value: "NP", label: "NP" },
  { value: "PA", label: "PA" },
  { value: "RN", label: "RN" },
  { value: "LPN", label: "LPN" },
  { value: "CNS", label: "CNS" },
  { value: "CNM", label: "CNM" },
  { value: "CRNA", label: "CRNA" },
  { value: "DDS", label: "DDS" },
  { value: "DMD", label: "DMD" },
  { value: "DPM", label: "DPM" },
  { value: "DC", label: "DC" },
  { value: "PSYD", label: "PsyD" },
  { value: "PHD", label: "PhD" },
  { value: "LCSW", label: "LCSW" },
  { value: "LPC", label: "LPC" },
  { value: "OT", label: "OT" },
  { value: "PT", label: "PT" },
  { value: "SLP", label: "SLP" },
  { value: "BHS", label: "BHS" },
  { value: "MA", label: "MA" },
  { value: "CM", label: "CM" },
];

//   {
//     value: "MD",
//     label: "MD",
//   },
//   {
//     value: "PA",
//     label: "PA",
//   },
//   {
//     value: "PSYD",
//     label: "PSYD",
//   },
//   {
//     value: "lcsw",
//     label: "LCSW",
//   },
//   {
//     value: "np",
//     label: "NP",
//   },
//   {
//     value: "nps",
//     label: "NP, S",
//   },
//   {
//     value: "rn",
//     label: "RN",
//   },
//   {
//     value: "bane",
//     label: "BHNP",
//   },
//   {
//     value: "fnp",
//     label: "FNP",
//   },
//   {
//     value: "rd",
//     label: "RD",
//   },
//   {
//     value: "none",
//     label: "None",
//   },
// ];

// added backend given provider user list
const PROVIDER_FORM_ROLE_LIST = [
  {
    value: "Psychiatrist",
    label: "Psychiatrist",
  },
  {
    value: "Therapist",
    label: "Therapist",
  },
  {
    value: "Nurse",
    label: "Nurse",
  },
  {
    value: "Provider",
    label: "Provider",
  },
];

export const PROVIDER_ROLE_RECORD: Record<string, string> = {
  ...PROVIDER_FORM_ROLE_LIST.reduce(
    (obj, item) => {
      obj[item.value] = item.label;
      return obj;
    },
    {} as Record<string, string>
  ),
};

export const PROVIDER_ROLE_LIST = [
  {
    value: "facility_admin",
    label: "Facility Admin",
  },
  {
    value: "specialist",
    label: "Specialist",
  },
  {
    value: "primary_care_admin",
    label: "Primary Care Provider",
  },
  {
    value: "physician_assistant",
    label: "Physician Assistant",
  },
  {
    value: "physician",
    label: "Physician",
  },
];

export const GENDER = [
  {
    value: "MALE",
    label: "Male",
  },
  {
    value: "FEMALE",
    label: "Female",
  },
  {
    value: "OTHER",
    label: "Other",
  },
];
export const COMMUNICATION_TYPE = [
  {
    value: "EMAIL",
    label: "EMAIL",
  },
  {
    value: "SMS",
    label: "SMS",
  },
  {
    value: "EMAIL_AND_SMS",
    label: "EMAIL & SMS",
  },
];

export const STATUS_APPOINTMENT: {
  label: string;
  value: string;
  selected?: boolean;
  color?: string;
}[] = [
  {
    label: "Scheduled",
    value: "PENDING",
    selected: true,
    color: "#4873B9",
  },
  {
    label: "Checked In",
    value: "CHECKED_IN",
    selected: true,
    color: "#E59EFF",
  },
  {
    label: "In Exam",
    value: "IN_EXAM",
    selected: true,
    color: "#4C34FF",
  },
  {
    label: "Signed Off",
    value: "COMPLETED",
    selected: false,
    color: "#00B216",
  },
  {
    label: "Confirmed",
    value: "CONFIRMED",
    selected: true,
    color: "#0097F0",
  },
  {
    label: "No Show",
    value: "NO_SHOW",
    selected: false,
    color: "#8B8B8B",
  },
  {
    label: "Canceled",
    value: "CANCELLED",
    selected: false,
    color: "#FF7E7E",
  },
  // {
  //   label: "Confirmed",
  //   selected: false,
  //   color: "#588BC1",
  // },
  // {
  //   label: "In Room- Intake",
  //   selected: false,
  //   color: "#1400FF80",
  // },
  // {
  //   label: "Cancelled",
  //   selected: false,
  //   color: "#FF7E7E",
  // },
  // {
  //   label: "No Show",
  //   selected: false,
  //   color: "#DD4BA5",
  // },
  {
    label: "Instant",
    value: "INSTANT",
    selected: false,
    color: "#b8ecd2",
  },
];

export const DIAGNOSTIC_CODE_TYPES = [
  { value: "ICD 09", label: "ICD 9" },
  { value: "ICD 10", label: "ICD 10" },
  { value: "ICD 11", label: "ICD 11" },
];

export const BOOKING_WINDOWS = [
  {
    value: "CUSTOM",
    label: "Custom",
  },
  {
    value: "1",
    label: "1 Week",
  },
  {
    value: "2",
    label: "2 Week",
  },
  {
    value: "3",
    label: "3 Week",
  },
  {
    value: "4",
    label: "4 Week",
  },
  {
    value: "5",
    label: "5 Week",
  },
  {
    value: "6",
    label: "6 Week",
  },
  {
    value: "12",
    label: "12 Week",
  },
  {
    value: "26",
    label: "26 Week",
  },
  {
    value: "52",
    label: "52 Week",
  },
];
